/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NewDocumentList } from '../../models/new-document-list';

export interface NewDocumentGetNewDocumentList$Params {
}

export function newDocumentGetNewDocumentList(http: HttpClient, rootUrl: string, params?: NewDocumentGetNewDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<NewDocumentList>> {
  const rb = new RequestBuilder(rootUrl, newDocumentGetNewDocumentList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NewDocumentList>;
    })
  );
}

newDocumentGetNewDocumentList.PATH = '/new-document/list';
